import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import creditCardUtility from '@sparta.credit-cards.utilities/credit-card-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';
import { htmlEscaper, token, cardDetails } from '@sparta.credit-cards.helpers/credit-cards/dist/es6.js';

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"campaign-properties-section\">\r\n</div>\r\n<div class=\"card-details-default\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":4,"column":44},"end":{"line":4,"column":58}}}))
    + "\"></div>\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row small-collapse medium-uncollapse large-uncollapse\">\r\n    <div class=\"column small-12\">\r\n      <h2 class=\"small-12 column show-for-medium-up cnx-light\">"
    + container.escapeExpression((lookupProperty(helpers,"token")||(depth0 && lookupProperty(depth0,"token"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"title") : stack1),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"token","hash":{},"data":data,"loc":{"start":{"line":4,"column":63},"end":{"line":4,"column":105}}}))
    + "</h2>\r\n    </div>\r\n  </div>\r\n  <div class=\"row small-collapse medium-uncollapse large-uncollapse feature-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"locations") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":32,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"finePrint") : stack1),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":2},"end":{"line":40,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasTooltips")),{"name":"if","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":2},"end":{"line":59,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"cardDetails")||(depth0 && lookupProperty(depth0,"cardDetails"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,(depths[1] != null ? lookupProperty(depths[1],"campaignProperties") : depths[1]),{"name":"cardDetails","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":31,"column":20}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"column small-12 feature\">\r\n      <div class=\"feature-content"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasTooltips")),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":33},"end":{"line":11,"column":85}}})) != null ? stack1 : "")
    + "\">\r\n        <h3 class=\"roboto-bold\">\r\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"CARD_PRODUCT_DETAILS_HEADER_XX") || (depth0 != null ? lookupProperty(depth0,"CARD_PRODUCT_DETAILS_HEADER_XX") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"CARD_PRODUCT_DETAILS_HEADER_XX","hash":{},"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":16,"column":46}}}) : helper))) != null ? stack1 : "")
    + "\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"hasTooltips")),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":10},"end":{"line":23,"column":17}}})) != null ? stack1 : "")
    + "        </h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"CARD_PRODUCT_DETAILS_CONTENTS_XX") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":8},"end":{"line":28,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    return " has-tooltips";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"CARD_PRODUCT_DETAILS_CONTENTS_XX") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),">",1,{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":10},"end":{"line":22,"column":22}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a id=\"detailsTooltipCta"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":21,"column":36},"end":{"line":21,"column":46}}}) : helper)))
    + "\" href=\"javascript:void(0);\" class=\"icon-link spa-ui-layer-link spa-fn spa-ui-layer-tooltip-link\" rel=\"detailsTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":21,"column":163},"end":{"line":21,"column":173}}}) : helper)))
    + "\" data-options='{\"layerType\":\"tooltip\",\"rel\":\"detailsTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":21,"column":233},"end":{"line":21,"column":243}}}) : helper)))
    + "\"},\"maxHeight\":\"280\",\"maxWidth\":\"400\"'></a>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"row collapse\">\r\n    <div class=\"column small-12\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"finePrint") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n";
},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"locations") : stack1),{"name":"each","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":2},"end":{"line":58,"column":11}}})) != null ? stack1 : "");
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"cardDetails")||(depth0 && lookupProperty(depth0,"cardDetails"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,(depths[1] != null ? lookupProperty(depths[1],"campaignProperties") : depths[1]),{"name":"cardDetails","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":2},"end":{"line":57,"column":18}}})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"CARD_PRODUCT_DETAILS_CONTENTS_XX") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),">",1,{"name":"compare","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":2},"end":{"line":56,"column":14}}})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"detailsTooltip"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":47,"column":25},"end":{"line":47,"column":35}}}) : helper)))
    + "\" class=\"hide\" data-options='{\"type\":\"info\"}'>\r\n    <div class=\"content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"CARD_PRODUCT_DETAILS_CONTENTS_XX") : depth0),{"name":"each","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":4},"end":{"line":53,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),">",0,{"name":"compare","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":4},"end":{"line":52,"column":16}}})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"campaignProperties") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":60,"column":7}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/card-details-cc-module",
  "version": "4.0.0",
  "id": "cardDetailsCcModule",
  "containerID": "creditCardsCardDetailsCcModule",
  "moduleName": "credit-cards-card-details-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "card-details-cc-module",
  "data": {
    "init": "cardDetailsCcModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "hasTooltips",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Displays first paragraph and adds any remaining paragraphs into a tooltip for all details section"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        compare,
        json,
        htmlEscaper,
        token,
        cardDetails
      },
      "partials": {
        "card-details-cc-partial": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "card-details-cc-partial": renderTemplate
  },
  "helpers": {
    compare,
    json,
    htmlEscaper,
    token,
    cardDetails
  },
  "dependencies": {
    "@sparta.credit-cards.helpers/credit-cards": "^3.0.0",
    "@sparta.credit-cards.utilities/credit-card-utility": "^3.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* global spaParams sparta */

/**
 * @export
 * @class cardDetailsCcModuleJS
 * @extends {Module}
 */
class cardDetailsCcModuleJS extends Module {
  /**
   * Construct the cardDetailsCcModuleJS class
   * @param {*} options - options for constructor
   * @param {*} context - context for constructor
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    const {
      target
    } = this.settings;
    this.content = JSON.parse(target.querySelector('.card-details-default').dataset.jcr);
    this.templatePartial = _moduleConfig.partials['card-details-cc-partial'];
  }

  /**
   * @returns {void}
   */
  init() {
    let campaignProperties;
    this.Events.sub('campaignProperties-spartaStore', data => {
      campaignProperties = data.data.data;
      const campaign = this.Store.getData('campaign');
      const linkContent = creditCardUtility.generateLinkContent(this.content, campaignProperties);
      const {
        target
      } = this.settings;
      const renderedTemplate = this.templatePartial({
        campaignProperties,
        campaign,
        content: linkContent,
        site: spaParams.siteParams,
        module: this.params
      });
      const byaPageEnable = campaignProperties.BYAPAGE_ENABLE;
      target.querySelector('.campaign-properties-section').innerHTML = renderedTemplate;
      this.setLinks(this.settings.target, byaPageEnable, campaign);
      this.Events.pub(creditCardUtility.EVENTS.productDetailsRendered, {
        module: this.settings.moduleInfo.name
      });
      this.initShowHideDetails(target);
    });
  }

  /**
   * Initializes the show/hide details spans as links to show/hide details content
   * @param {HTMLElement} target - this.settings.target passthrough
   * @returns {void}
   */
  initShowHideDetails(target) {
    let link;
    const details = target.querySelector('p.details');
    if (details) {
      details.style.marginBottom = '0px';
      const showDetailsSpan = target.querySelector('span.showDetails');
      const hideDetailsSpan = target.querySelector('span.hideDetails');
      // Wrap the elements in an <a> tag
      [showDetailsSpan, hideDetailsSpan].forEach(el => {
        if (!el) return;
        link = document.createElement('a');
        link.innerHTML = el.outerHTML;
        link.setAttribute('href', 'javascript:void(0);'); // eslint-disable-line
        link.classList.add(el.classList[0]);
        link.classList.add('detailsLink'); // Have to split it out due to IE
        el.parentNode.insertBefore(link, el);
        if (!('remove' in Element.prototype)) {
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        } else {
          el.remove();
        }
      });
      creditCardUtility.delegateEvent('click', 'a.detailsLink', this.toggleActiveClass.bind(this, details), false, target);
    }
  }

  /**
   * Toggles the active class
   * @param {Element} el - element that needs parent toggled
   * @returns {void}
   */
  toggleActiveClass(el) {
    // eslint-disable-line
    el.parentNode.classList.toggle('active');
  }

  /**
   * Sets apply and bya links on page
   * @param {Element} target - module target
   * @param {Boolean} byaPageEnable - Flag to direct to BYA page first
   * @param {Object} campaign - Data for this campaign
   * @returns {void}
   */
  setLinks(target, byaPageEnable, campaign) {
    if (byaPageEnable && byaPageEnable.toLowerCase() === 'yes') {
      this.setByaLinks(target.querySelectorAll('a.apply'), campaign);
    } else {
      this.setApplyLinks(target.querySelectorAll('a.apply'), campaign);
    }
  }

  /**
   * Sets apply link query params
   * @param {NodeList} linkEls - List of all elements to set links of
   * @param {Object} campaign - Data for this campaign
   * @returns {void}
   */
  setApplyLinks(linkEls, campaign) {
    let href = `${spaParams.siteParams.abpaEndpoint}`;
    href += `?requesttype=${this.params.requesttype || 'c'}`;
    href += `&campaignid=${campaign.campaignID}`;
    href += `&productoffercode=${campaign.poCode}`;
    href += `&locale=${campaign.locale}`;
    [...linkEls].forEach(linkEl => {
      linkEl.setAttribute('href', href);
    });
  }

  /**
   * setByaLinks
   *
   * @description Sets the BYA links
   * @param {NodeList} linkEls - List of all elements to set links of
   * @param {Object} campaign - Data for this campaign
   * @returns {void}
   */
  setByaLinks(linkEls, campaign) {
    //eslint-disable-line
    let href = `${spaParams.siteParams.siteRoot}/before-you-apply/`;
    if (sparta.language !== 'en') {
      href += `${sparta.language}/`;
    }
    [...linkEls].forEach(linkEl => {
      linkEl.setAttribute('href', `${href}?campaign=${campaign.campaignID}~${campaign.poCode}~${campaign.locale}`);
    });
  }
}
registerModuleClass({
  moduleClass: cardDetailsCcModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { cardDetailsCcModuleJS as default, moduleConfig };
